










































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { UserModel, UserStoreViewModel } from '@/models/admin/users';
import { Base } from '@/components/common/base';
import { VFields } from '@/models/v-fields';
import { ChangePasswordViewModel } from '@/models/admin/users';
import { Utils } from '@/helper/utils';
import { AddInspectionForm } from '@/Alynk.dtos';
import { mapGetters } from 'vuex';
import {userService,storeService,accountService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    ...mapGetters({ isStoreSelected: 'getIsStoreSelect' }),
  },
  components:{
    Availability: () => import('@/views/account/availability/save.userprofile.vue'),
  }
})
export default class UserProfile extends Base {
  public user: UserModel = {
    userStores: [],
  };
  public drawer: boolean = false;
  public isShownStoreSelected: boolean = false;
  public appStore: any;
  public panel = { detail: false, password: false, store: false };
  public seletedStore: number = 0;
  public userStores: UserStoreViewModel[] = [];
  public userId: string = '';
  public changePasswordModel: ChangePasswordViewModel = {};
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public userLoading: boolean = false;
  public requestProgress: boolean = false;
  public storeLoading: boolean = false;
  public passwordLoading: boolean = false;
  public hasUserStores: boolean = false;
  public isStoreSelected: boolean;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('userProfile.alertInvalidForm'));
      } else {
        this.submitPassword();
      }
    } else if (methodName === 'backToDashboard') {
      this.$router.push({ name: 'app.dashboard' });
    } else if (methodName === 'defaultStoreSubmit') {
      this.submit();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public addChangePasswordButtons(): void {
    const buttons: any = [];
    this.updateToolBar(buttons);
  }
   public addSetDefaultStoreButtons(): void {
    const buttons: any = [];
    this.updateToolBar(buttons);
  }
  public addAvailabilityStatusButtons(): void {
    const buttons: any = [];
    // buttons.push({
    //   id: '0',
    //   type: 'button',
    //   title: this.$parent.$t('userProfile.btnTitleBackToDashboard'),
    //   disabled: false,
    //   visible: true,
    //   class: 'btn',
    //   label: this.$parent.$t('userProfile.btnTitleBackToDashboard'),
    //   click: 'backToDashboard',
    //   icon: 'fas fa-arrow-left',
    // });
    this.updateToolBar(buttons);
  }
  public updateToolBar(additionalButtons): void {
    let buttons: any = [];
    if (additionalButtons) {
      buttons = buttons.concat(additionalButtons);
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.isShownStoreSelected = this.isStoreSelected;
     // Toolbar
    this.updateToolBar(null);
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    setInterval(()=>{
      if(screen.width > 599){
        this.drawer = true;
      }
    }, 1000);
    this.drawer = true;
    this.getUserInfo();
    this.getDefaultStore();
    this.getLoggedUserStore();
    this.setFields();
    this.addWatch();
    this.appStore = this.appStores;
  }

  public hindetab() {
    if (this.drawer) {
      this.drawer = false;
    } else {
      this.drawer = true;
    }
  }

  public async getDefaultStore(): Promise<void> {
    try {
      this.storeLoading = true;
      this.requestProgress = true;
      const respose = await userService.getDefaultStoreAsync();
      this.seletedStore = respose.defaultStoreId;
    } finally {
      this.storeLoading = false;
      this.requestProgress = false;
    }
  }
  public setFields(): void {
    this.formFields = [
      {
        key: 'oldPassword',
        type: 'v-alynk-text-field',
        required: true,
        validators: {},
        templateOptions: {
          label: this.$t('userProfile.lblOldPassword') as string,
          validations: 'required',
          required: true,
          disabled: false,
          type: 'password',
        },
      },
      {
        key: 'newPassword',
        type: 'v-alynk-text-field',
        required: true,
        validators: {
          regex: (field, model, next) => {
            next(Utils.PasswordRegex.test(model[field.key]));
          },
        },
        templateOptions: {
          label: this.$t('userProfile.lblNewPassword') as string,
          validations: 'required',
          required: true,
          disabled: false,
          type: 'password',
          hint: Utils.PasswordHint,
        },
      },
      {
        key: 'confirmPassword',
        type: 'v-alynk-text-field',
        required: true,
        validators: {
          regex: (field, model, next) => {
            next(Utils.PasswordRegex.test(model[field.key]));
          },
        },
        templateOptions: {
          label: this.$t('userProfile.lblConfirmPassword') as string,
          validations: 'required',
          required: true,
          disabled: false,
          type: 'password',
          hint: Utils.PasswordHint,
        },
      },
    ];
  }
  public async getUserInfo(): Promise<void> {
    try {
      this.userLoading = true;
      const user = await userService.getCurrentUserInfoAsync();
      this.userId = user.userId;
      const response = await userService.getUserByIdAsync(this.userId);
      this.user = response;
    } finally {
      this.userLoading = false;
    }
  }
  public async getLoggedUserStore(): Promise<void> {
    try {
      this.storeLoading = true;
      this.requestProgress = true;
      const stores = await storeService.getUserEnterpriseStores();
      this.userStores = stores.results;
      if (this.userStores.length > 0) {
        this.hasUserStores = true;
      } else {
        this.hasUserStores = false;
      }
    } finally {
      this.storeLoading = false;
      this.requestProgress = false;
    }
  }
  public async submit(): Promise<void> {
    try {
      this.requestProgress = true;
      this.$emit('update:progress', this.requestProgress);
      await userService.setDefaultStoreAsync(this.seletedStore);
      this.showAlert(true, this.$t('userProfile.alertDefaultStoreSet'));
    } finally {
      this.requestProgress = false;
      this.$emit('update:progress', this.requestProgress);
    }
  }
  public async submitPassword(): Promise<void> {
    try {
      this.passwordLoading = true;
      this.$emit('update:progress', this.passwordLoading);
      await accountService.changePassword(this.changePasswordModel);
      this.showAlert(true, this.$t('userProfile.alertPasswordUpdated'));
      accountService.logout(this);
      // location.href = '/app/account/login';
    } finally {
      this.passwordLoading = false;
      this.$emit('update:progress', this.passwordLoading);
    }
  }
  public addWatch(): void {
    this.$watch('changePasswordModel.newPassword', (newVal, oldVal) => {
      if (newVal !== this.changePasswordModel.confirmPassword) {
        this.$set(this.form.$errors.newPassword, 'passwordMatching', true);
        this.$set(this.form.$errors.confirmPassword, 'passwordMatching', true);
      } else {
        this.$set(this.form.$errors.newPassword, 'passwordMatching', false);
        this.$set(this.form.$errors.confirmPassword, 'passwordMatching', false);
      }
    });
    this.$watch('changePasswordModel.confirmPassword', (newVal, oldVal) => {
      if (newVal !== this.changePasswordModel.newPassword) {
        this.$set(this.form.$errors.newPassword, 'passwordMatching', true);
        this.$set(this.form.$errors.confirmPassword, 'passwordMatching', true);
      } else {
        this.$set(this.form.$errors.newPassword, 'passwordMatching', false);
        this.$set(this.form.$errors.confirmPassword, 'passwordMatching', false);
      }
    });
  }

  public setToggle(prop: string): void {
    const keys = Object.keys(this.panel);
    this.panel[prop] = !this.panel[prop];
    keys.forEach((key) => {
      if (key !== prop) {
        this.panel[key] = false;
      }
    });
  }
}
